import { AuthNavLink } from '@/components/astro/new-design-25/ui/subcomponents/auth-nav-link';
import { CtaButton } from './subcomponents/cta-button';
import { SqueezeLogo } from './subcomponents/logo';

export function SqueezeNav({ onCta }: { onCta: () => void }) {
  return (
    <div className='mx-auto flex max-w-[1160px] items-center justify-between border-b border-steel-120 px-4 py-5 sm:px-7'>
      <SqueezeLogo />
      <div className='flex items-center gap-3 sm:gap-4'>
        <AuthNavLink
          align='end'
          anonymous='none'
          className='text-sm font-semibold text-steel-880 hover:text-azure-595 max-sm:hidden sm:text-[14.5px]'
        />
        <CtaButton
          className='px-5 py-2.5 text-sm sm:text-[14.5px]'
          onClick={onCta}
        />
      </div>
    </div>
  );
}
